export enum Icon {
  LightOff = 'bds/light-off/24',
  LightOn = 'bds/light-on/24',
  Coupe = 'coupe',
  Convertible = 'convertible',
  Fullscreen = 'bds/fullscreen/24',
  FullscreenExit = 'bds/fullscreen-exit/24',
  ScreenMirroring = 'bds/open-new/24',
  ScreenMirroringExit = 'bds/close/24',
  Camera = 'bds/camera/24',
  ThreeSixty = 'view-360'
}

export enum ThreeSixtyInteriorDataUpdateState {
  AnimateFinished = 'animateFinished',
  MouseUp = 'mouseUp'
}

export enum TrackingId {
  StageViewId = 'StageView',
  StageViewStateId = 'Lights',
  ThreeSixtyToggleId = 'ThreeSixtyToggle',
  RoofStateId = 'Rooftop',
  FullscreenModeId = 'Fullscreen',
  ExteriorThreeSixtyInteractionId = 'Exterior360_Interaction',
  InteriorThreeSixtyInteractionId = 'Interior360_Interaction',
  GoToTrunkId = 'Trunk',
  ScreenMirrorId = 'screenmirror'
}

export enum ScreenMode {
  NonFullscreen = 0,
  Fullscreen = 1
}

export enum MimeType {
  WebP = 'image/webp',
  Png = 'image/png',
  Jpeg = 'image/jpeg'
}

// Stage Perspectives provides interior sphere (BISx i.e BIS1 to BIS6) which is used to create a cube-like room for interior 360
// The order of stage perspectives is as follows: front, left, back, right, up, down i.e counter-clockwise
// See link https://confluence.mercedes-benz.io/display/OWCC/Stage
export enum InteriorThreeSixtyPerspective {
  Front = 0,
  Left = 1,
  Back = 2,
  Right = 3,
  Up = 4,
  Down = 5
}
